module.exports = __webpack_public_path__ + "img/57600.1dc3208a.jpg";